export const iconFontAwesomeMoneyPesoSign = (
	<i className="fa-solid fa-peso-sign"></i>
);
